import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import "./ui.css";
import EmptyState from "../common/EmptyState";
import TableSkeleton from "./TableSkeleton";

// Generic table shell: green/white header, consistent row height/padding/
// hover, and its own overflow-x wrapper (the table container scrolls,
// never the page). Columns declare header label/alignment/min-width;
// row markup itself stays with the caller (`children`, typically a
// `<tbody>` built from the caller's own data) since every page's row
// shape is different -- this only standardizes the chrome around it.
export function TableHeader({ columns }) {
  return (
    <thead>
      <tr>
        {columns.map((col) => (
          <th key={col.key} className={col.align === "center" ? "ui-th-center" : ""} style={col.minWidth ? { minWidth: col.minWidth } : undefined}>
            {col.label}
          </th>
        ))}
      </tr>
    </thead>
  );
}

export default function DataTable({ columns, loading, empty, emptyIcon, emptyTitle, emptyMessage, children }) {
  const isEmpty = !loading && empty;
  const stateKey = loading ? "loading" : isEmpty ? "empty" : "loaded";
  return (
    <div className="ui-table-wrap">
      <AnimatePresence mode="wait" initial={false}>
        <motion.div
          key={stateKey}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.15 }}
        >
          {loading ? (
            <TableSkeleton columns={columns} />
          ) : isEmpty ? (
            <EmptyState icon={emptyIcon} title={emptyTitle} message={emptyMessage} />
          ) : (
            <table className="ui-table">
              <TableHeader columns={columns} />
              <tbody>{children}</tbody>
            </table>
          )}
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
